import { render } from "./Recordings.vue?vue&type=template&id=0721a7b0"
import script from "./Recordings.vue?vue&type=script&lang=js"
export * from "./Recordings.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__